<template>
    <div id="app">
        <Header></Header>
        <div class="home">
            <el-row
                    style="text-align: center; margin-top: 80px"
            >
                <h1>事件风暴面板</h1>
            </el-row>
            <el-row style="text-align: center; margin-top: 30px">
                <img width="721px" src="@/assets/eventstorming2.png"/>
            </el-row>
            <el-row style="text-align: center; margin-top: 30px">
                <h1>在线工具</h1>
            </el-row>
            <el-row :gutter="12" style="margin-top: 50px;text-align: center;">
                <el-col :span="8">
                    <el-card shadow="always">
                        <h3>授权共同维护</h3>
                    </el-card>
                </el-col>
                <el-col :span="8">
                    <el-card shadow="always">
                        <h3>多人协同风暴</h3>
                    </el-card>
                </el-col>
                <el-col :span="8">
                    <el-card shadow="always">
                        <h3>低碳、绿色(无需纸标签)</h3>
                    </el-card>
                </el-col>
            </el-row>

            <el-row style="text-align: center; margin-top: 80px">
                <h1>EventStorming(事件风暴)</h1>
            </el-row>
            <el-row :gutter="12" style="margin-top: 50px">
                <el-col :span="8">
                    <el-card shadow="always">
                        <h3>Big Picture EventStorming</h3>
                        <p>
                            Big Picture EventStorming
                            是一个单一的大型研讨会，涉及我们期望合作解决关键业务问题的所有关键人员。
                            我们将建立整个业务线的行为模型，突出协作、边界、责任以及相关参与者和利益相关者的不同观点
                        </p>
                    </el-card>
                </el-col>
                <el-col :span="8">
                    <el-card shadow="always">
                        <h3>Design Level EventStorming</h3>
                        <p>
                            完整版Big Picture，实现DDD-CQRS/ES. [Domain-Driven
                            Design, Command-Query Responsibility Segregation and
                            Event Sourcing.]<br>
                            <b>CQRS</b>:命令查询职责分离<br>
                            <b>ES</b>:事件溯源
                        </p>
                    </el-card>
                </el-col>
                <el-col :span="8">
                    <el-card shadow="always">
                        <h3>Value-Driven EventStorming</h3>
                        <p>
                            一种进入价值流映射的快速方法，使用讲故事作为一个可能的平台。
                        </p>
                    </el-card>
                </el-col>
            </el-row>

            <el-row :gutter="12" style="margin-top: 50px">
                <el-col :span="8">
                    <el-card shadow="always">
                        <h3>UX-Driven EventStorming</h3>
                        <p>专注于追求可用性和完美执行的用户/客户旅程</p>
                    </el-card>
                </el-col>
                <el-col :span="8">
                    <el-card shadow="always">
                        <h3>回顾EventStorming</h3>
                        <p>
                            使用领域事件来确定流程的基线并扩大范围以寻找改进机会
                        </p>
                    </el-card>
                </el-col>
                <el-col :span="8">
                    <el-card shadow="always">
                        <h3>EventStorming 作为学习工具</h3>
                        <p>完美地最大化新员工的学习</p>
                    </el-card>
                </el-col>
            </el-row>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
import Footer from "../../components/Footer";
import Header from "../../components/Header";

export default {
    metaInfo: {
        title: "事件风暴,EventStorming,IT技术知识分享", // set a title
        meta: [
            {
                // set meta
                name: "keywords",
                content:
                    "事件风暴,EventStorming,Big Picture,Design Level,DDD,CQRS,ES",
            },
            {
                name: "description",
                content:
                    "事件风暴EventStorming 是一个单一的大型研讨会，涉及我们期望合作解决关键业务问题的所有关键人员。 我们将建立整个业务线的行为模型，突出协作、边界、责任以及相关参与者和利益相关者的不同观点",
            },
        ],
    },
    name: "Home",
    components: {
        Header,
        Footer,
    },
};
</script>
